import React, { useEffect } from 'react';
import './HelpOverlay.css';

interface HelpOverlayProps {
  onClose: () => void;
}

const HelpOverlay: React.FC<HelpOverlayProps> = ({ onClose }) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  return (
    <div className="help-overlay">
      <div className="help-content">
        <div className="help-header">
          <h2>How to Play Heroes of the Grid</h2>
          <span className="help-close-btn" onClick={onClose} role="button" tabIndex={0}>×</span>
        </div>

        <div className="help-body">
          <section className="help-section">
            <div className="help-section-header">Getting Started</div>
            <ul>
              <li><strong>Characters:</strong> View and manage your heroes. Each character has unique stats and abilities.</li>
              <li><strong>World Map:</strong> Explore different regions and start battles against monsters.</li>
              <li><strong>Crafting:</strong> Create weapons, armor, and items using materials gathered from battles.</li>
            </ul>
          </section>

          <section className="help-section">
            <div className="help-section-header">Battle System</div>
            <ul>
              <li><strong>Turn Order:</strong> Characters act based on initiative (Dexterity stat).</li>
              <li><strong>Action Points (AP):</strong> Used to perform attacks and cast skills.</li>
              <li><strong>Movement:</strong> Click "Move" then click a highlighted tile to move your character.</li>
              <li><strong>Attacking:</strong> Click "Attack" then click an enemy in range to attack.</li>
              <li><strong>Skills:</strong> Click "Cast Skill", select a skill, then target an enemy or area.</li>
            </ul>
          </section>

          <section className="help-section">
            <div className="help-section-header">Character Stats</div>
            <ul>
              <li><strong>HP (Health Points):</strong> When it reaches 0, your character falls in battle.</li>
              <li><strong>Strength:</strong> Increases physical damage.</li>
              <li><strong>Vitality:</strong> Increases max HP.</li>
              <li><strong>Constitution:</strong> Increases max HP and defense.</li>
            </ul>
          </section>

          <section className="help-section">
            <div className="help-section-header">Tips</div>
            <ul>
              <li>Position your characters wisely - ranged units work best from a distance!</li>
              <li>Use the terrain to your advantage - enemies must move to reach you.</li>
              <li>Don't forget to craft equipment to boost your stats.</li>
              <li>Gather materials from battles to unlock more powerful recipes.</li>
              <li>Balance your team with different character classes for best results.</li>
            </ul>
          </section>
        </div>

        <div className="help-footer">
          <span className="help-got-it-btn" onClick={onClose} role="button" tabIndex={0}>Got it!</span>
        </div>
      </div>
    </div>
  );
};

export default HelpOverlay;
